// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PP6X","fullView":"styles_fullView__3ldUy"};